import script from "./BingCryptoWhiteListForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BingCryptoWhiteListForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__